import getConfig from 'next/config'

import { ClientTrackingContextProvider } from '@fe-toolkit/utility/client/tracking-context'

import { type ReactNode } from 'react'

import { basePath } from '@/constants/constants'

import { useMemberContext } from './MemberContext'

const { publicRuntimeConfig } = getConfig()

const ctcConfig = {
  baseUrl: publicRuntimeConfig.PUBLIC_API_URL,
  mfeBasePath: basePath,
  withDebug: publicRuntimeConfig.DEV_TOOLS_ENABLED,
}

const CTCProviderWrapper = ({ children }: { children: ReactNode }) => {
  const { data } = useMemberContext()
  const memberId = data?.data?.id ?? undefined

  return <ClientTrackingContextProvider config={{ ...ctcConfig, memberId }}>{children}</ClientTrackingContextProvider>
}

export default CTCProviderWrapper
